import React from 'react';
import { Sparkles, Scissors, ShieldCheck, Layers } from 'lucide-react';
export function FeaturesSection() {
  return <section className="py-24 bg-white" data-id="element-51">
      <div className="container mx-auto px-4" data-id="element-52">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24" data-id="element-53">
          <div data-id="element-54">
            <h2 className="text-4xl md:text-5xl font-serif mb-8 leading-tight" data-id="element-55">
              No son simples calcetines. <br data-id="element-56" />
              <span className="text-stone-500 italic" data-id="element-57">
                Son el marco perfecto para tu calzado.
              </span>
            </h2>
            <div className="space-y-6 text-lg text-gray-600 leading-relaxed" data-id="element-58">
              <p data-id="element-59">
                Caminas por la calle y sientes que tu outfit está "bien", pero
                le falta algo. Tienes las botas, tienes la falda o los leggings,
                pero visualmente falta una transición. Falta ese volumen que
                solo la piel sintética de alta calidad puede dar.
              </p>
              <p data-id="element-60">
                Diseñados para la mujer que no teme ser el centro de atención.
                Estos calentadores están inspirados en la estética vintage y
                urbana que hoy domina las tendencias globales.
              </p>
            </div>
          </div>
          <div className="relative h-[600px] bg-stone-100 overflow-hidden" data-id="element-61">
            <img src="https://cdn.magicpatterns.com/uploads/fhi2SusqxkHz25ER4hHAm7/2.webp" alt="Calentadores blancos de piel sintética con botas UGG" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" data-id="element-62" />
          </div>
        </div>

        <div className="text-center mb-16" data-id="element-63">
          <h3 className="text-3xl font-serif mb-4" data-id="element-64">
            ¿Por qué estos y no otros?
          </h3>
          <div className="w-24 h-1 bg-black mx-auto" data-id="element-65"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-66">
          {/* Feature 1 */}
          <div className="p-8 bg-stone-50 hover:bg-stone-100 transition-colors duration-300 group" data-id="element-67">
            <div className="mb-6 inline-flex p-3 bg-white rounded-full shadow-sm group-hover:scale-110 transition-transform" data-id="element-68">
              <Sparkles className="w-6 h-6 text-stone-800" data-id="element-69" />
            </div>
            <h4 className="text-xl font-serif font-bold mb-4" data-id="element-70">
              Textura Ultra-Suave
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-71">
              Seleccionamos una fibra sintética que imita la caída y el brillo
              natural de la piel, sin crueldad animal. Se sienten tan bien como
              se ven.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="p-8 bg-stone-50 hover:bg-stone-100 transition-colors duration-300 group" data-id="element-72">
            <div className="mb-6 inline-flex p-3 bg-white rounded-full shadow-sm group-hover:scale-110 transition-transform" data-id="element-73">
              <Layers className="w-6 h-6 text-stone-800" data-id="element-74" />
            </div>
            <h4 className="text-xl font-serif font-bold mb-4" data-id="element-75">
              Versatilidad de Estilo
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-76">
              Úsalos sobre tus botas favoritas para un look invernal
              sofisticado, o con zapatos de plataforma para una estética
              alternativa.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="p-8 bg-stone-50 hover:bg-stone-100 transition-colors duration-300 group" data-id="element-77">
            <div className="mb-6 inline-flex p-3 bg-white rounded-full shadow-sm group-hover:scale-110 transition-transform" data-id="element-78">
              <Scissors className="w-6 h-6 text-stone-800" data-id="element-79" />
            </div>
            <h4 className="text-xl font-serif font-bold mb-4" data-id="element-80">
              Ajuste Inteligente
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-81">
              Desde los 15 cm hasta los 40 cm de cobertura, se adaptan a tu
              pierna sin deslizarse, manteniendo su volumen durante todo el día.
            </p>
          </div>

          {/* Feature 4 */}
          <div className="p-8 bg-stone-50 hover:bg-stone-100 transition-colors duration-300 group" data-id="element-82">
            <div className="mb-6 inline-flex p-3 bg-white rounded-full shadow-sm group-hover:scale-110 transition-transform" data-id="element-83">
              <ShieldCheck className="w-6 h-6 text-stone-800" data-id="element-84" />
            </div>
            <h4 className="text-xl font-serif font-bold mb-4" data-id="element-85">
              Protección con Estilo
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-86">
              En esos días frescos, añaden una capa de calor donde más se
              necesita, permitiéndote usar tus faldas favoritas incluso cuando
              baja la temperatura.
            </p>
          </div>
        </div>
      </div>
    </section>;
}